// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.code-analysis-component {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
  height: 200px;
  margin-top: 120px;
}
.code-analysis-component:before {
  content: "Tech Stack";
  position: absolute;
  top: -220px;
  left: -20px;
  z-index: -1;
  font-family: "Abril Fatface", serif;
  font-size: 5em;
  color: #cacaca;
}

.skill-wrapper {
  display: flex;
  position: relative;
  cursor: default;
  transition: transform 500ms ease-in-out;
  padding: 1em;
}
.skill-wrapper:first-child {
  top: -20px;
}
.skill-wrapper:nth-child(n+1) {
  top: -20px;
}
.skill-wrapper:nth-child(2n) {
  top: -80px;
}
.skill-wrapper:nth-child(4n) {
  top: -120px;
}
.skill-wrapper:hover {
  transform: scale(1.2);
}
.skill-wrapper:hover ul.subskills {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 600ms 300ms ease-out, transform 600ms 150ms ease-out;
}

.graphbar {
  position: relative;
  display: block;
  width: 6px;
  margin-right: 1em;
  background: #00adb5;
  transition: height 1.2s 300ms ease-out;
}
.graphbar:before {
  content: "";
  position: absolute;
  display: block;
  width: 2px;
  height: 200px;
  top: 0;
  left: -6px;
  background: #222831;
  z-index: -1;
}

.skill-info h4 {
  font-family: "Abril Fatface", serif;
  font-size: 1.8em;
  font-weight: 300;
  margin: 0;
  color: #989898;
}
.skill-info .percentage {
  font-size: 2em;
  font-family: "Abril Fatface", serif;
  line-height: 1;
}

ul.subskills {
  list-style: none;
  margin: 0;
  padding: 0;
  opacity: 0;
  color: #989898;
  transform: translateY(-40px);
  transition: opacity 200ms 0ms ease-out, transform 800ms 0ms ease-out;
}

.not-in-view .graphbar {
  height: 0 !important;
}

@media screen and (max-width: 900px) {
  .code-analysis-component {
    position: relative;
    margin-top: 0;
  }
  .code-analysis-component:before {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    z-index: auto;
    font-family: "Abril Fatface", serif;
    font-size: 2.6em;
    margin-bottom: 1em;
    color: #222831;
  }
  .code-analysis-component .skill-wrapper {
    top: 0 !important;
  }
  .code-analysis-component .graphbar {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/code-analysis/code-analysis.component.sass","webpack://./src/_partials/_variables.sass"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AADD;AAGC;EACC,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mCChBY;EDiBZ,cAAA;EACA,cAAA;AADF;;AAGA;EACC,aAAA;EACA,kBAAA;EACA,eAAA;EACA,uCAAA;EACA,YAAA;AAAD;AAEC;EACC,UAAA;AAAF;AAEC;EACC,UAAA;AAAF;AAEC;EACC,UAAA;AAAF;AAEC;EACC,WAAA;AAAF;AAEC;EACC,qBAAA;AAAF;AAEE;EACC,UAAA;EACA,wBAAA;EACA,wEAAA;AAAH;;AAEA;EACC,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,mBCnDe;EDoDf,sCAAA;AACD;AACC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,mBC5DW;ED6DX,WAAA;AACF;;AAEC;EACC,mCCpEY;EDqEZ,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,cCpEW;ADqEb;AACC;EACC,cAAA;EACA,mCC5EY;ED6EZ,cAAA;AACF;;AACA;EACC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,cChFY;EDiFZ,4BAAA;EACA,oEAAA;AAED;;AAEC;EACC,oBAAA;AACF;;AAEA;EACC;IACC,kBAAA;IACA,aAAA;EACA;EACA;IACC,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,aAAA;IACA,mCCzGW;ID0GX,gBAAA;IACA,kBAAA;IACA,cCzGU;ED0GX;EACA;IACC,iBAAA;EACD;EACA;IACC,aAAA;EACD;AACF","sourcesContent":["@import \"../../../_partials/variables\"\n\n.code-analysis-component\n\tposition: relative\n\tdisplay: flex\n\tflex-wrap: wrap\n\tjustify-content: space-around\n\twidth: 100%\n\theight: 200px\n\tmargin-top: 120px\n\n\t&:before\n\t\tcontent: 'Tech Stack'\n\t\tposition: absolute\n\t\ttop: -220px\n\t\tleft: -20px\n\t\tz-index: -1\n\t\tfont-family: $font-header\n\t\tfont-size: 5em\n\t\tcolor: #cacaca\n\n.skill-wrapper\n\tdisplay: flex\n\tposition: relative\n\tcursor: default\n\ttransition: transform 500ms ease-in-out\n\tpadding: 1em\n\n\t&:first-child\n\t\ttop: -20px\n\n\t&:nth-child(n+1)\n\t\ttop: -20px\n\n\t&:nth-child(2n)\n\t\ttop: -80px\n\n\t&:nth-child(4n)\n\t\ttop: -120px\n\n\t&:hover\n\t\ttransform: scale(1.2)\n\n\t\tul.subskills\n\t\t\topacity: 1\n\t\t\ttransform: translateY(0)\n\t\t\ttransition: opacity 600ms 300ms ease-out, transform 600ms 150ms ease-out\n\n.graphbar\n\tposition: relative\n\tdisplay: block\n\twidth: 6px\n\tmargin-right: 1em\n\tbackground: $primary-color\n\ttransition: height 1.2s 300ms ease-out\n\n\t&:before\n\t\tcontent: ''\n\t\tposition: absolute\n\t\tdisplay: block\n\t\twidth: 2px\n\t\theight: 200px\n\t\ttop: 0\n\t\tleft: -6px\n\t\tbackground: $text-color\n\t\tz-index: -1\n\n.skill-info\n\th4\n\t\tfont-family: $font-header\n\t\tfont-size: 1.8em\n\t\tfont-weight: 300\n\t\tmargin: 0\n\t\tcolor: $link-color\n\n\t.percentage\n\t\tfont-size: 2em\n\t\tfont-family: $font-header\n\t\tline-height: 1\n\nul.subskills\n\tlist-style: none\n\tmargin: 0\n\tpadding: 0\n\topacity: 0\n\tcolor: $link-color\n\ttransform: translateY(-40px)\n\ttransition: opacity 200ms 0ms ease-out, transform 800ms 0ms ease-out\n\n\n.not-in-view\n\t.graphbar\n\t\theight: 0 !important\n\n\n@media screen and (max-width: 900px)\n\t.code-analysis-component\n\t\tposition: relative\n\t\tmargin-top: 0\n\n\t\t&:before\n\t\t\tposition: relative\n\t\t\ttop: 0\n\t\t\tleft: 0\n\t\t\twidth: 100%\n\t\t\tz-index: auto\n\t\t\tfont-family: $font-header\n\t\t\tfont-size: 2.6em\n\t\t\tmargin-bottom: 1em\n\t\t\tcolor: $text-color\n\n\t\t.skill-wrapper\n\t\t\ttop: 0 !important\n\n\t\t.graphbar\n\t\t\tdisplay: none\n","$font-main: 'Raleway', sans-serif\n$font-header: 'Abril Fatface', serif\n$primary-color: #00adb5\n$secondary-color: #f89d33\n$text-color: #222831\n$link-color: #989898\n$highlights-color: rgba(121, 216, 221, .6)\n$background-color: #eee\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
